<div class="navbar-header" [ngClass]="[fuseConfig.layout.navbar.secondaryBackground, 'env-' + environmentName]">
    <div class="logo">
        <img alt="" class="logo-icon" src="../../../../../assets/images/logos/hub.svg" />
        @switch (environmentName) {
            @case ("Development") {
                <span class="logo-text">Mediaclip&nbsp;Dev</span>
            }
            @case ("Staging") {
                <span class="logo-text">Mediaclip&nbsp;Staging</span>
            }
            @default {
                <span class="logo-text">Mediaclip&nbsp;Hub</span>
            }
        }
    </div>

    <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" aria-label="Minimize navigation">
        <mat-icon>menu</mat-icon>
    </button>

    <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" aria-label="Hide navigation">
        <mat-icon>arrow_back</mat-icon>
    </button>
</div>

<div class="navbar-content" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
    <fuse-navigation layout="vertical"></fuse-navigation>
</div>
